import { BigNumber as NS } from 'bignumber.js';
var ServerSections;
(function (ServerSections) {
    ServerSections["spot"] = "spot";
    ServerSections["futures"] = "futures";
})(ServerSections || (ServerSections = {}));
var Sections;
(function (Sections) {
    Sections["spot"] = "\u0421\u043F\u043E\u0442";
    Sections["futures"] = "\u0424\u044C\u044E\u0447\u0435\u0440\u0441";
})(Sections || (Sections = {}));
var OrderTypes;
(function (OrderTypes) {
    OrderTypes["stopLoss"] = "STOP";
    OrderTypes["takeProfit"] = "TAKE_PROFIT";
    OrderTypes["stopLossLimit"] = "STOP_LOSS_LIMIT";
    OrderTypes["takeProfitLimit"] = "TAKE_PROFIT_LIMIT";
    OrderTypes["stopLossMarket"] = "STOP_MARKET";
    OrderTypes["takeProfitMarket"] = "TAKE_PROFIT_MARKET";
})(OrderTypes || (OrderTypes = {}));
var TransferSides;
(function (TransferSides) {
    TransferSides["long"] = "\u041B\u043E\u043D\u0433";
    TransferSides["short"] = "\u0428\u043E\u0440\u0442";
    TransferSides["stopLoss"] = "SL";
    TransferSides["takeProfit"] = "TP";
})(TransferSides || (TransferSides = {}));
const getOrderDirection = (side, type) => {
    switch (type) {
        case OrderTypes.stopLossMarket: {
            return TransferSides.stopLoss;
        }
        case OrderTypes.takeProfitMarket: {
            return TransferSides.takeProfit;
        }
        default: {
            return side === 'BUY' ? TransferSides.long : TransferSides.short;
        }
    }
};
export const setTrueFieldsNamesSpot = (list) => {
    return list.reduce((acc, curr) => {
        const body = {
            ticker: curr.symbol,
            volume: NS(curr.quantity).abs(),
            positionPrice: NS(curr.price),
            direction: getOrderDirection(curr.side, curr.type),
            section: curr.source === ServerSections.spot ? Sections.spot : Sections.futures,
            id: curr.orderId,
            closing: false
        };
        acc.push(body);
        return acc;
    }, []);
};
